module.exports = __webpack_public_path__ + "static/assets/e0bae2b2b7f89b42c78dc7f81a44d2ac.gif";